import { render, staticRenderFns } from "./footerLine.vue?vue&type=template&id=367125ef&scoped=true"
import script from "./footerLine.vue?vue&type=script&lang=js"
export * from "./footerLine.vue?vue&type=script&lang=js"
import style0 from "./footerLine.vue?vue&type=style&index=0&id=367125ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367125ef",
  null
  
)

export default component.exports